// packages
import { h } from 'preact';
import * as d3 from 'd3';
import { getStartEndDate } from '../utils/chart-utils';

// components
import PureComponent from './PureComponent';

class MiniChart extends PureComponent {
  constructor() {
    super();

    this.getContainerWidth = this.getContainerWidth.bind(this);
    this.createChart = this.createChart.bind(this);
    this.redrawChart = this.redrawChart.bind(this);

    this.state = {
      width: null,
      height: 150,
      bodyWidth: null,
      breakPoint: 544,
    };
  }

  createChart(section, data, scale, type) {
    let { width, height, bodyWidth, breakPoint } = this.state;

    let colors = {
      bars_default: '#348094',
      bars_weekly: '#348094',
      bars_totals_statewide: '#d1d1d1',
      bars_totals: '#348094',
    };



    if (bodyWidth > breakPoint) width = width / 6;
    else width = width / 4;

    if (bodyWidth > breakPoint) height = width;
    else height = 150;

    // Get the start and end date for all of the data
    let dateStart = new Date('2020-03-18T00:00:00-05:00');
    let dateEnd = getStartEndDate(data, 'last', 'Spring2021Chart', 'end_date');

    // chart setup
    let margin = { top: 25, bottom: 22, right: 30, left: 35 };

    // adjust right margins on mobile
    if (bodyWidth > 544) margin.right = 40;
    else margin.right = 30;

    let svg = d3
      .select(`.mini-chart-${section}-${type}`)
      .append('svg')
      .attr('width', width + margin.left + margin.right)
      .attr('height', height + margin.top + margin.bottom);

    let g = svg
      .append('g')
      .attr('class', `mini-chart-${section}-chart-group`)
      .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

    svg
      .append('text')
      .attr('x', (width + margin.left + margin.right) / 2)
      .attr('y', margin.top - 15)
      .attr('text-anchor', 'middle')
      .attr('class', 'chart_label')
      .text(`${capitalize(type)} resident deaths`);

    function capitalize(word) {
      return word[0].toUpperCase() + word.slice(1).toLowerCase();
    }

    let max_scale;

    if (type == 'weekly') max_scale = d3.max(data[1].deathWeeks, d => d[scale]);
    else max_scale = d3.max(data[3].deathWeeks, d => d[scale]);

    // set ranges
    let x = d3.scaleTime().domain([dateStart, dateEnd]).range([0, width]);

    let y = d3.scaleLinear().domain([0, max_scale]).range([height, 0]).nice();

    let xAxis = g =>
      g
        .call(
          d3
            .axisBottom(x)
            .ticks(2)
            .tickValues([dateStart, dateEnd])
            .tickSize(0)
            .tickPadding(10)
            .tickFormat(d => {
              return (
                d.toLocaleString('default', { month: 'long' }) +
                ' ' +
                d.getFullYear()
              );
            })
        )
        .attr('transform', `translate(0,${height})`)
        .attr('class', 'axis axis--x');

    let yAxis = g =>
      g
        .call(
          d3
            .axisLeft(y)
            .ticks(6)
            .tickSize(0)
            .tickFormat((d, i) => {
              // Gets only the second and last tick
              if (i == 1 || i == 4) return d3.format(',')(d);
            })
        )
        .attr('class', 'axis axis--y');

    g.append('g').call(xAxis);
    g.append('g').call(yAxis);

    // start out line and fill variables for step chart

    data.forEach((section_data, section_index) => {
      let sectionName = section_data.sectionName;
      let deathWeeks = section_data.deathWeeks;

      let fill = `M${x(d3.min(deathWeeks, d => d['date']))},${height}`;

      deathWeeks.forEach((d, i) => {
        let y0 = y(d[scale]),
          x0 = x(d.end_date);

        fill += `V${y0}H${x0}`;
      });

      fill += `V${height}Z`;

      let fillColor;

      if (section == sectionName && type == 'weekly')
        fillColor = colors['bars_default'];
      else if (section == sectionName && type == 'total')
        fillColor = colors['bars_totals'];
      else fillColor = '#f0f0f0';

      g.append('path')
        .attr('class', 'path-fill-mini')
        .attr('d', fill)
        .style('fill', fillColor);
    });
  }

  redrawChart() {
    const { section, data, scale, type } = this.props;

    d3.selectAll(`.mini-chart-${section}-${type} svg`).remove();
    let { width, bodyWidth } = this.getContainerWidth();

    this.setState({ width: width, bodyWidth: bodyWidth });
    this.createChart(section, data, scale, type);
  }

  getContainerWidth() {
    let base;

    base = d3.select('.data-section');

    const body = d3.select('body');

    const width = base.node().offsetWidth;
    const bodyWidth = body.node().offsetWidth;

    return { width, bodyWidth };
  }

  componentDidMount() {
    const { section, data, scale, type } = this.props;
    let { width, bodyWidth } = this.getContainerWidth();

    this.setState({ width: width, bodyWidth: bodyWidth }, () => {
      this.createChart(section, data, scale, type);
    });

    window.addEventListener('resize', () => {
      this.redrawChart();
    });
  }

  componentWillUnmount() {
    window.addEventListener('resize', () => {
      this.redrawChart();
    });
  }

  render() {
    const { section, type } = this.props;

    return (
      <div class={`mini-timeline-chart mini-chart-${section}-${type}`}></div>
    );
  }
}

export default MiniChart;
